import { REACTION_SINAL } from './Word';

export class Feedback {
  constructor(
    public userName: string = '',
    public userId: string = '',
    public text: string = '',
    public type: REACTION_SINAL = REACTION_SINAL.POSITIVO,
    public wordKey: string = '',
    public key?: string
  ) { }
}
